<template>
  <with-actions>
    <div class="form-inline" slot="context-actions">
      <router-link class="btn btn-primary" :to="{ name: 'automation_create' }">{{
        'create_automation' | t
      }}</router-link>
    </div>
    <div class="card" v-if="automations.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'action' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(a, idx) in automations">
            <td>
              <router-link :to="{ name: 'automation_edit', params: { automation_id: a.id } }"
                >{{ 'when_a' | t }} <strong>{{ a.trigger.model_type | t }}</strong> {{ 'is' | t }}
                <strong>{{ a.trigger.event | t }}</strong> {{ 'then' | t }}
                <strong>{{ format_job_types(a) }}</strong></router-link
              >
            </td>
            <td class="text-right">
              <strong
                ><a @click="spin($event, destroy, a, idx)">{{ 'delete' | t | titlecase }}</a></strong
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h3 v-if="automations.length === 0">No automations yet</h3>
  </with-actions>
  <!---->
</template>
<script>
import _ from 'lodash';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts';
import moment from 'moment-es6';

export default {
  data: function () {
    return {
      automations: []
    };
  },
  async mounted() {
    let o = {
      to: { name: 'automations' },
      text: this.$t('routes_automations')
    };
    this.setBreadcrumbs([{ to: { name: 'settings_index' }, text: this.$t('settings') }, o]);

    let { data } = await Api.findAll('automations');

    this.automations = data;
  },
  methods: {
    format_job_types(automation) {
      return _.map(automation.actions, (a) => {
        if (a.job_type === 'UpdateRecordJob') {
          let key = _.find(a.additional_attributes, (attr) => attr.attr_key === 'attribute').attr_value;
          let value = _.find(a.additional_attributes, (attr) => attr.attr_key === 'value').attr_value;
          return `${this.$t('set')} ${key} ${this.$t('to')} ${value}`;
        } else {
          return this.$t(a.job_type);
        }
      }).join(', ');
    },
    async destroy(automation, idx) {
      await Api.destroy('automations', automation.id);
      this.automations.splice(idx, 1);
    }
  }
};
</script>

<style scoped></style>
